import authServiceSagas from 'modules/auth/services/sagas';
import turnServiceSagas from 'modules/turn/services/sagas';
import userServiceSagas from 'modules/user/services/sagas';
import { all } from 'redux-saga/effects';
import shopServiceSagas from 'services/shop/sagas';
export default function* rootSaga() {
  yield all([
    userServiceSagas(),
    authServiceSagas(),
    shopServiceSagas(),
    turnServiceSagas(),
  ]);
}
